import axios from "axios";
export default {
  name: "navbarSection",
  data() {
    return {
      pageType: true,
      Article: [],
      activeClassNavBar: "activeNavbarLink",
      numberProducts: 0,
      ArticlesBasket:[],
      search:""
    };
  },
  created() {
    // if ((this.$router.history.current.path=="/wishlist-friend")||(this.$router.history.current.path=="/wishlist")) {      this.pageType = false;
    // }
    var nb = window.localStorage.getItem("ProductNumber");
    for (var i = 1; i <= nb; i++) {
      let product = JSON.parse(window.localStorage.getItem("product" + i))
      axios
        .get(
          "https://giftstore-blog.herokuapp.com/api/product/get/" + product.id
        )
        .then((response) => {
          this.Article.push(response.data.fetchedArticle);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
    var TabThemes = [];
    var ProNum = this.GetProductNumber();
    for (var k = 1; k <= ProNum; k++) {
      TabThemes.push(localStorage.getItem("product" + k));
    }
    this.$store.commit("setbasket", TabThemes);
    if (window.localStorage.getItem("Giftstore-U")) {
      axios
        .post("https://giftstore-blog.herokuapp.com/api/user/getUser", {
          userId: window.localStorage.getItem("Giftstore-U"),
        })
        .then((response) => {
          console.log("user info",response)
          this.$store.commit("setUserInfo", response.data.user);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
    this.activeUser()
  },
  watch: {
    $route(to, from) {
      if (to.path == "/wishlist-friend" || to.path == "/wishlist") {
        this.pageType = false;
      } else {
        this.pageType = true;
      }
    },
  },
  computed: {
    currentPage() {
      return this.$router.app._route.fullPath;
    },
  },
  methods: {
    articleSearch(){
      return "/articles-search?search="+this.search
    },
    activeUser(){
      if(this.$route.query.idActive){
        this.$store.commit("setActiveUser", window.localStorage.getItem("Giftstore-U"));
      }
    },
    whishlistPage() {
      this.$store.commit("setActiveUser", window.localStorage.getItem("Giftstore-U"));
      return "/wishlist?idActive=" + window.localStorage.getItem("Giftstore-U");
    },
    UserArticleBasket() {
      this.ArticlesBasket=[]
      var nb=window.localStorage.getItem("ProductNumber")
      
      for (var i = 1; i <= nb; i++) {
        // console.log("basla",JSON.parse(window.localStorage.getItem("product"+i)) )
        // this.ArticlesBasket.push(JSON.parse(window.localStorage.getItem("product"+i)))
        // console.log('pannier', this.ArticlesBasket)
       var objectItem = JSON.parse(window.localStorage.getItem("product"+i))
       var idElement= objectItem.id
       axios
          .get(
            "https://giftstore-blog.herokuapp.com/api/product/get/" +
            idElement
          )
          .then((response) => {
            // for (let j = 1; j <= nb; j++) {
            //   if((window.localStorage.getItem("product"+j))==response.data.fetchedArticle._id){
            //     this.ArticlesBasket.push(Object.assign({"numberElement":"product"+j},response.data.fetchedArticle))            }
            // }
            console.log("test159",response);
            this.ArticlesBasket.push(response.data.fetchedArticle)
          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    },
    numberWhislit() {
      if (this.$store.getters.getUserInfo.wishList) {
        return this.$store.getters.getUserInfo.wishList.length;
      } else {
        return 0;
      }
    },
    GetProductNumber() {
      //extracting the theme number from local storage
      if (localStorage.getItem("ProductNumber") === null) {
        return 0;
      } else {
        return localStorage.getItem("ProductNumber");
      }
    },
    numberProduct() {
      console.log("basket", this.$store.getters.getbasket);
      if (
        (this.numberProducts == this.$store.getters.getbasket) !=
        "undefined"
      ) {
        this.numberProducts = this.$store.getters.getbasket.length;
      }

      return this.numberProducts;
    },
    userConnected() {
      if (window.localStorage.getItem("Giftstore-U")) {
        return false;
      } else {
        return true;
      }
    },
    signOut() {
      console.log("ee");
      window.localStorage.removeItem("Giftstore-U");
      window.localStorage.removeItem("Giftstore-T");
      this.$store.commit("setUserInfo", {});
      console.log("store", this.$store.getters.getUserInfo);
      this.$router.push({ name: "loginandregister" });
    },
    cartImg(image) {
      return (
        "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + image
      );
    },
  },
};
